import { Injectable } from '@angular/core';
import { ApiUrlsConstant } from '../../../app-constant';
import { Observable, of } from 'rxjs';
import { ResponseVm } from '../../models/response-vm';
import { BaseHttpService } from '../shared-services/base-http.service';
import { HttpHeaders } from '@angular/common/http';
import { WebFormCheckout } from '../../models/checkout/web-form-submit';

@Injectable({
  providedIn: 'root'
})
export class OrderService extends BaseHttpService {
  apiUrls: any = ApiUrlsConstant;

  generateExcel(data: any): Observable<any> {
    // Simulate an API call that returns the URL of the generated Excel file 
    return this.post<any>(this.apiUrls.generateExcel, data);
  }
  uploadFiles(file1: File, clientId: number, CountryISO: string,ActionType:string,poNumber:string,invoiceEmail:string): Observable<ResponseVm> {
    // const response = new ResponseVm();
    // response.responseCode = "1000";
    // response.responseMessage = "File uploaded successfully";
    // return of(response);


    const formData: FormData = new FormData();
    formData.append('OrdersFile', file1, file1.name);
    formData.append('ClientId', clientId.toString());
    formData.append('CountryISO', CountryISO.toString());
    formData.append('PoNumber', poNumber.toString());
    formData.append('InvoiceEmail', invoiceEmail.toString());
    formData.append('ActionType', ActionType.toString());
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    return this.post<ResponseVm>(this.apiUrls.ordersUpload, formData, headers);
  }
  submitWebForm(request: WebFormCheckout) : Observable<ResponseVm>{
   
  return this.post<ResponseVm>(this.apiUrls.webFormOrdersSave, request);
  }

}
